<div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
  <div class="row row-with-bottom-padding">
    <div class="col-md-12">
    
      <div class="auth-box">

        <div class="logo-above-auth-box logo-tenant-as-background"></div>
     
         <!-- content -->
         <div class="auth-box-content-wrapper">

          <h2>{{ 'create-acc.done-title' | translate }}</h2>
          
          <p>
            {{ 'create-acc.success-msg' | translate }}
          </p>

          </div>  
      </div>

    </div>
  </div>
</div>